import type { RoulettePrize } from '@/types/roulette';

// Fonte única da raridade da roletinha — consumida pelo grid de "Prêmios
// Disponíveis" e pelo modal de resultado (fita + glow). Faixas, selos e cores
// ficam aqui pra não divergirem entre os dois lugares.

export type RarityTier =
  | 'legendary'
  | 'supreme'
  | 'epic'
  | 'rare'
  | 'common'
  | 'loss';

// Faixa de raridade pela chance (menor = mais raro). Derrota é neutra; sem
// display_probability cai em "comum".
export function rarityTier(prize: RoulettePrize): RarityTier {
  if (prize.isLoss) return 'loss';

  const chance = prize.displayProbability;

  if (chance === null) return 'common';
  if (chance <= 3) return 'legendary'; // Lendário: 0 < p ≤ 3
  if (chance <= 5) return 'supreme'; //   Supremo:  3 < p ≤ 5
  if (chance <= 7) return 'epic'; //       Épico:    5 < p ≤ 7
  if (chance <= 10) return 'rare'; //      Raro:     7 < p ≤ 10

  return 'common'; //                      Comum:    p > 10
}

// Selo textual da raridade (derrota não ganha selo).
export const RARITY_LABELS: Record<RarityTier, string> = {
  legendary: 'Lendário',
  supreme: 'Supremo',
  epic: 'Épico',
  rare: 'Raro',
  common: 'Comum',
  loss: '',
};

// Cor (selo/chance/barra/fita) e glow por tier. Aplicadas via CSS vars
// (--rar-color / --rar-glow) nos componentes.
export const RARITY_COLORS: Record<
  RarityTier,
  { color: string; glow: string }
> = {
  legendary: { color: '#ff3700', glow: '#ff3700' },
  supreme: { color: '#c026d3', glow: '#f0abfc' },
  epic: { color: '#38bdf8', glow: '#67e8f9' },
  rare: { color: '#17c964', glow: '#86efac' },
  common: { color: '#ffffff', glow: '#ffffff' },
  loss: { color: '#475569', glow: 'transparent' },
};

// CSS vars da raridade prontas pra bind em :style.
export function rarityStyle(prize: RoulettePrize): Record<string, string> {
  const { color, glow } = RARITY_COLORS[rarityTier(prize)];

  return { '--rar-color': color, '--rar-glow': glow };
}
